import React from 'react';
import { useFormContext } from 'react-hook-form';
import PaymentDonutChart from '../PaymentDonutChart/PaymentDonutChart.js';
import { useLastValidPayemntValues, calculateMonthlyPMI, calculateMonthlyMIP } from './VALoanCalculator.utils.js';

function VALoanCalculatorDonutChart(_ref) {
  var isFHAEnabled = _ref.isFHAEnabled,
    isMortgageComponent = _ref.isMortgageComponent;
  var form = useFormContext();
  var lastValidValues = useLastValidPayemntValues(form);
  var chartDataProps = {
    monthlyPayment: lastValidValues.calculations.monthlyPayment,
    monthlyPI: lastValidValues.calculations.monthlyPI,
    monthlyPropertyTax: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyPropertyTax : 0,
    monthlyHomeownersInsurance: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyHomeownersInsurance : 0,
    monthlyPMI: isMortgageComponent && lastValidValues.fields.includePMI ? calculateMonthlyPMI(lastValidValues.fields.homePrice, lastValidValues.fields.downPayment, lastValidValues.loanProgram) : 0,
    monthlyHOA: lastValidValues.calculations.monthlyHOA,
    monthlyMIP: isFHAEnabled && lastValidValues.fields.includeMIP ? calculateMonthlyMIP(lastValidValues.fields.homePrice - lastValidValues.fields.downPayment, lastValidValues.fields.homePrice, lastValidValues.fields.loanProgram) : 0,
    isFHAEnabled: isFHAEnabled
  };
  return /*#__PURE__*/React.createElement(PaymentDonutChart, chartDataProps);
}

export { VALoanCalculatorDonutChart as default };
